module.exports = __webpack_public_path__ + "img/ph_engine.fb9a2131.jpg";